import { createNotificationCommandService } from '../application/createNotificationCommandService';
import { supabaseNotificationWritePort } from '../infrastructure/supabaseNotificationPort';

export const notificationCommandService = createNotificationCommandService(supabaseNotificationWritePort);
